import React from "react";
import HostelPreviewCard from "./HostelPreviewCard.component";
import AddIcon from "../../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import HostelStore from "../../../../../../store/Operational/Residential/Hostel";
const HostelBody = ({ setAddHostelModal }) => {
  const { setAction, setHostelId } = HostelStore();

  return (
    <div className="flex align-start justify-start flex-1 h-full scroll-x">
      <div className="flex align-start justify-start g-1">
        <HostelPreviewCard
          onViewDetails={() => {
            setHostelId("1");
            setAction(1);
          }}
        />
        <HostelPreviewCard
          onViewDetails={() => {
            setHostelId("2");
            setAction(1);
          }}
        />
        <div className="flex-col align-start justify-start">
          <button
            className="transparentBtn flex-row align-center justify-start g-05"
            style={{ border: "none" }}
            onClick={() => setAddHostelModal(true)}
          >
            <img
              src={AddIcon}
              alt="plusicon"
              style={{ width: "2rem", height: "2rem" }}
            />
            <span className="t-17 poppins">Add Hostel</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostelBody;
